import React, { useState, useEffect, useRef } from 'react';

const AnnouncementBox = () => {
    const listRef = useRef(null);
    const [isHovered, setIsHovered] = useState(false); // Track hover state

    useEffect(() => {
        const interval = setInterval(() => {
            if (listRef.current && !isHovered) { // Only scroll if not hovered
                const scrollHeight = listRef.current.scrollHeight;
                const clientHeight = listRef.current.clientHeight;

                // Check if the bottom of the list is reached
                if (listRef.current.scrollTop + clientHeight >= scrollHeight) {
                    listRef.current.scrollTop = 0; // Reset scroll to the top when it reaches the bottom
                } else {
                    listRef.current.scrollTop += 1; // Scroll down gradually
                }
            }
        }, 30); // Speed of the scrolling (lower is faster)

        return () => clearInterval(interval); // Cleanup on component unmount
    }, [isHovered]); // Re-r) => clearInterval(interval); // Cleanup interval on component unmount


    return (
        <>
            <div className="announcement-box rounded shadow-sm p-3 pt-0 mb-5 bg-white"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)} >
                <div className="announcement-title  text-white text-center p-2 font-weight-bold" style={{ backgroundColor: "#1d3243 " }}>
                    Announcements
                </div>
                <div
                    className="announcement-list"
                    style={{ maxHeight: '200px', overflow: 'hidden', position: 'relative' }}
                    ref={listRef}
                >
                    <ul style={{ listStyleType: "disc" }} className=" p-2 m-0">

                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="/assets/events/Graduation-day-invitation-2025.pdf" target="_blank">
                                Graduation Day Invitation - 21st June 2025
                            </a>
                            

                        </li>
                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="/assets/NBA-STATUS.png" target="_blank">
                                UG Programmes(CSE,IT, ECE & EEE) Accredited by NBA(Tier-I) 2025
                            </a>
                        </li>
                        
                        <li className="bg-white  small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a href="../assets/events/ETM-2025.pdf" target="_blank" className="text-dark">
                                One Week FDP on Effective Teaching Methods and Strategies
                            </a>
                        </li>
                        <li className="bg-white  small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="http://mrecw.3pixelsonline.in/enquiry.html" target="_blank">
                                Admissions Open for A.Y 2025-26

                            </a>
                        </li>
                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="https://www.mallareddyecw.com/Home/Examschedules" target="_blank">
                                B.Tech Regular/Supply Time Tables 2025
                            </a>
                        </li>
                        <li className="bg-white small" style={{ fontSize: '14px', color: '#000080' }}>
                            <a className="text-dark" href="https://www.mallareddyecw.com/Home/AcademicNotifications" target="_blank">
                                Results,RC&RV Notifications 2025
                            </a>
                        </li>
                        {/* Add more announcements here */}
                    </ul>
                </div>
                <div className="announcement-footer  text-center" style={{ backgroundColor: "#1d3243 " }}>
                    <a href="#" className="d-block p-2 font-weight-bold text-white text-decoration-none">
                        View All
                    </a>
                </div >
            </div >
        </>
    );
};

export default AnnouncementBox;
